import { AuthState } from './interface';

export const authInitialState: AuthState = {
    isLoading: false,
    loadingError: false,
    showConfirmRegister: false,
    showConfirmResetPassword: false,
    user: null,
    issuer: null,
    session: null,
    didRegister: false,
    didLogin: false,
    showConfirmEmail: ''
};